import { zonesTypes } from "../constantes/actionTypes"

const initialState = []

export const zones = (state = initialState, action) => {
    switch (action.type) {
        case zonesTypes.GET_ALL_ZONES_SUCCESS:
            return action.payload
        case zonesTypes.GET_ALL_ZONES_FAILURE:
            return initialState
        default:
            return state
    }
}